import type { OrganizationWeekPlannerLocales } from '../types';

const organizationWeekPlannerLocales: OrganizationWeekPlannerLocales = {
  addAssignment: 'Nieuwe opdracht',
  alertInterestJobNoLongerAssigned48HrsMessage:
    'Deze keuzeopdracht begint binnen 48 uur, maar er is geen freelancer gekozen. Deze dienst is nu niet meer beschikbaar voor freelancers om op te reageren. Zet de dienst om in een spoeddienst!',
  alertInterestShownWithoutAssignedFreelancerMessage:
    'Er hebben freelancers gereageerd op deze keuzedienst. Je kan iemand toewijzen!',
  alertPersonalJobStartsTomorrowNotAcceptedMessage:
    'Deze dienst begint morgen, maar de uitgenodigde freelancer heeft nog niet geaccepteerd!',
  areYouSureYouWantToContinue: 'Weet je zeker dat je door wilt gaan?',
  assignmentDate: 'Date assignment',
  assignments: 'Opdrachten',
  assignmentType: 'Type opdracht',
  cancelBulkDialogMessage:
    'Als je die opdrachten hebt geannuleerd, kun je dit niet ongedaan maken. Gebruik het veld om de freelancers een bericht te sturen over de reden van opzegging.',
  cancelDialogMessage:
    'Als je deze opdracht hebt geannuleerd, kun je deze niet ongedaan maken. Gebruik het veld om de freelancer een bericht te sturen over de reden van opzegging.',
  cancelJob: 'Opdracht annuleren',
  compensateMessage:
    'Deze annulering is binnen 24 uur voor aanvang van de dienst. Dat betekent dat er een 100 compensatie is voor de freelancer die ingepland is.',
  contractRequestMsg:
    'Let op: U kunt maximaal drie keer per dag contracten aanvragen.',
  contractRequestSuccess:
    'We zijn uw aanvraag aan het verwerken, u ontvangt een e-mail met de gevraagde contracten',
  contracts: 'Contracten',
  contractsExport: 'Contracten exporteren',
  date: 'Datum',
  endDate: 'Einddatum',
  explanation: 'Toelichting',
  explanationOfAbsence: 'Toelichting afwezigheid',
  exportContracts: 'Export contracten',
  feedbackDialogBodyMessage:
    'Op %{date} heeft %{freelancer} bij jullie een dienst gedraaid. Wat vonden jullie van de samenwerking?',
  feedbackDialogBodyTitle: 'Wat vond je van %{freelancer}',
  feedbackDialogHeaderTitle: 'Freelancer Beoordelen',
  filters: 'Filters',
  freelancerName: 'Naam freelancer',
  goBack: 'Ga terug',
  grid: 'Rooster',
  importFromSDB: 'Importeer uit SDB',
  jobBulkCancel: {
    one: 'Opdracht annuleren',
    other: 'Opdrachten annulerenn',
  },
  jobPopoverAgreement: 'Overeenkomst',
  // jobPopoverAssignFreelancer: 'Freelancer toewijzen',
  jobPopoverAssignmentDetails: 'Details Opdracht',
  jobPopoverBlockFreelancerFromOrganization: 'Uitsluiten (bedrijf)',
  jobPopoverBlockFreelancerInLocation: 'Uitsluiten (vestiging)',
  jobPopoverCancelAssignment: 'Annuleer opdracht',
  jobPopoverConfirm: 'Bevestigen',
  jobPopoverConvertToUrgent: 'Omzetten naar spoeddienst',
  jobPopoverEdit: 'Bewerken',
  jobPopoverFavoriteFreelancerForLocation: 'Favoriete freelancer (vestiging)',
  jobPopoverFavoriteFreelancerForOrganization: 'Favoriete freelancer (bedrijf)',
  jobPopoverFeedback: 'Beoordelen',
  jobPopoverHours: 'Uren',
  jobPopoverNoShow: 'Afwezig / Ziek',
  jobPopoverRepeatAssignment: 'Herhaalopdracht',
  jobPopoverSplit: 'Splitsen (Ochtend/Middag)',
  jobPopoverUnblockFreelancerFromOrganization: 'Toelaten (bedrijf)',
  jobPopoverUnblockFreelancerInLocation: 'Toelaten (vestiging)',
  jobPopoverUnfavoriteFreelancerForLocation:
    'Ontfavoriete freelancer (vestiging)',
  jobPopoverUnfavoriteFreelancerForOrganization:
    'Ontfavoriete freelancer (bedrijf)',
  jobStatus: 'Opdrachtstatus',
  jobStatusAssigned: 'Toegewezen',
  jobStatusOpen: 'Open',
  jobType: 'Opdrachttype',
  jobTypeInterest: 'Keuze',
  jobTypePersonal: 'Persoonlijk',
  JobTypeReplacement: 'Spoed',
  lateCancellationCompensation: 'Compensatie voor late annulering',
  location: 'Locatie',
  locations: 'Vestigingen',
  maxMessageLengthErrorMessage: {
    one: 'maximale lengte: %{count} teken',
    other: 'maximale lengte: %{count} tekens',
  },
  minMessageLengthErrorMessage: {
    one: 'minimale lengte: %{count} teken',
    other: 'minimale lengte: %{count} tekens',
  },
  noResultsTable:
    'We konden geen diensten vinden op basis van de huidige filters. Pas de filters aan of neem contact op met Tadaah support.',
  noResultsTableTitle: 'Geen diensten gevonden',
  noshowDialogMessage:
    'In het geval van afwezigheid van freelancer kan je dit hier melden. Gebruik het veld om een toelichting te geven over de afwezigheid.',
  personenregisterAlertMessage:
    'Binnenkort komen er pedagogisch medewerkers bij jullie werken, die volgens onze administratie nog niet gekoppeld zijn in het personenregister. Kijk hier om wie het gaat.',
  personRegister: 'Personenregister',
  personRegisterTooltip:
    'Klik hier voor de Personenregister Controle Hulp om te zien of er pedagogisch medewerkers ingepland staan die volgens onze administratie nog niet gekoppeld zijn in het personenregister.',
  planner: 'Planner',
  ratingCannotBeEmpty: 'Beoordeling mag niet leeg zijn',
  reasonOfCanceling: 'Reden van annuleren',
  ReportAbsence: 'Afwezigheid melden',
  requestContracts: 'Contracten aanvragen',
  ResetFilters: 'Filters resetten',
  searchBoxPlaceholder: 'Zoek opdracht/freelancer',
  searchDates: 'Selecteer Data',
  searchFreelancer: 'Zoek Freelancer',
  searchLocation: 'Zoek Locatie',
  searchOrganisation: 'Zoek Organisatie',
  selectedJobs: {
    one: '%{count} dienst geselecteerd',
    other: '%{count} diensten geselecteerd',
  },
  selectEndDate: 'selecteer einddatum',
  selectFreelancer: 'Zoek freelancer',
  selectLocation: 'Zoek locatie',
  selectOrganization: 'Zoek organisatie',
  selectStartDate: 'Selecteer startdatum',
  sendFeedback: 'Beoordeling opsturen',
  startDate: 'Startdatum',
  table: 'Tabel',
  thisIsIntrestAssignment: 'Dit is een keuzedienst',
  thisIsPersonalAssignment: 'Dit is een persoonlijke dienst',
  thisIsUrgentAssignment: 'Dit is een spoeddienst',
  timeEndTime: 'Tijd/eindtijd',
  yesCancelJob: 'Ja, annuleer opdracht',
  yesReportAbsence: 'Ja, meld afwezigheid',
};

export default organizationWeekPlannerLocales;
